import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/it/text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bc1b60e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bc1b60e', __exports__)) {
    api.reload('5bc1b60e', __exports__)
  }
  
}


export default __exports__